import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css"; // Bootstrap styles
import "./index.css"; // Custom global styles
import ContactManager from "./ContactManager"; // Import from components folder

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ContactManager />
  </React.StrictMode>
);
